import { Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Channel } from 'icreate/common/models/channel';

@Component({
    selector: 'app-channel-search-input',
    templateUrl: './channel-search-input.component.html',
    styleUrl: './channel-search-input.component.css',
    standalone: false,
})
export class ChannelSearchInputComponent implements OnChanges {
    @Input() channels: Channel[];
    @Input() selectedChannel: Channel;
    @Output() onChannelSelected: EventEmitter<Channel> = new EventEmitter();
    @Output() onChannelHasError: EventEmitter<boolean> = new EventEmitter();

    isFocused: boolean = false;
    inputValue: string;
    filteredChannels: Channel[] = [];
    hasError: boolean = false;

    @HostListener('document:keydown.enter', ['$event'])
    handleEnterKey(event: KeyboardEvent) {
        if (this.filteredChannels?.length == 1) {
            this.selectChannel(this.filteredChannels[0]);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.channels && this.channels?.length > 0) {
            this.filterList(true);
        }
    }

    filterList(isInitial = false) {
        if (this.inputValue) {
            this.filteredChannels = this.channels.filter(channel => {
                const name = this.getChannelName(channel).toLowerCase();
                return name.includes(this.inputValue.toLowerCase());
            });
        } else {
            this.filteredChannels = this.channels;
        }

        if (!isInitial) {
            this.checkError();
        }
    }

    getChannelName(channel: Channel) {
        return `${channel.fcuData.fcuChannelId} ${channel.opsData.name}`;
    }

    selectChannel(channel) {
        this.onChannelSelected.emit(channel);
        this.isFocused = false;
        this.inputValue = null;
    }

    checkError() {
        if (this.isFocused) this.hasError = this.inputValue?.length > 0 && this.filteredChannels.length == 0;
        else this.hasError = this.inputValue?.length > 0 && !this.selectedChannel;

        this.onChannelHasError.emit(this.hasError);
    }
}
